<template>
  <div>
    <span
      v-for="installationStatusData of installationSummaryStatus"
      style="padding: 8px; font-weight: 700;"
    >
      {{ installationStatusData.name }}: {{ installationStatusData.total }}#;
      {{ installationStatusData.percentageOfTotal }}%;
      {{ format(installationStatusData.totalInjection) }}kWh;
      {{ installationStatusData.percentageInjectionOfTotal }}% |
    </span>
  </div>
</template>

<script>
/// <reference path="../types/index.js" />
import { formatNumberWithThousandSeparator } from '../../../utils/index';
export default {
  props: {
    /**
     * @type {InstallationSummary[]}
     */
    installationSummaryStatus: {
      required: true,
      type: Array,
    },
  },
  methods: {
    format(totalInjection) {
      return formatNumberWithThousandSeparator(totalInjection);
    },
  },
};
</script>
